export const SITE_URL = 'https://www.terminus.io';
export const BUSINESS_PHONE = '0571-26883999';
export const BUSINESS_EMAIL = 'contact@terminus.io';

export const HOME_SEO = {
  title: '杭州端点网络科技有限公司-新商业软件提供商-数字化转型-全链路解决方案',
  description:
    '端点科技是国内新商业软件提供商、国家高新技术企业。核心产品体系 AIP 企业智慧管理平台以 AI 驱动企业运营，覆盖战略决策、生产计划、供应链、财务等关键环节，帮助规模型企业实现从战略到落地的全链路智能闭环，包含 AI管理驾驶舱、业务应用、AI智能平台、Trantor 软件构建平台，并提供 Erda 企业数字化平台等企业级软件产品。',
  keywords:
    '端点,terminus,端点科技,杭州端点网络科技有限公司,AIP,企业智慧管理平台,企业AI平台,AI管理,AI管理驾驶舱,业务应用,AI智能平台,Trantor,Erda,企业软件,数字化转型,全链路解决方案,ERP,供应链系统,SaaS'
};

const provider = {
  '@type': 'Organization',
  name: '杭州端点网络科技有限公司',
  url: `${SITE_URL}/`
};

const aipProductSystem = {
  '@type': 'SoftwareApplication',
  name: 'AIP 企业智慧管理平台',
  url: `${SITE_URL}/`
};

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '杭州端点网络科技有限公司',
  alternateName: ['端点科技', 'Terminus'],
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/images/logo.png`,
  description:
    '端点科技是国内新商业软件提供商、国家高新技术企业。核心产品体系 AIP 企业智慧管理平台以 AI 的认知、推理与决策能力构建企业 AI 管理框架，覆盖战略决策、生产计划、供应链、财务等关键环节，帮助企业实现从战略意图到业务落地的全链路智能闭环。',
  foundingDate: '2012',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '杭州',
    addressRegion: '浙江',
    addressCountry: 'CN'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'sales',
    email: BUSINESS_EMAIL,
    telephone: BUSINESS_PHONE
  }
};

export const AIP_PRODUCT_SCHEMAS = {
  aifoundation: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'AI智能平台',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    provider,
    isPartOf: aipProductSystem,
    description: '企业级AI构建平台，支持AI应用从构建、评测、观测到优化的全生命周期管理。',
    url: `${SITE_URL}/aip/aifoundation`
  },
  aivault: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'AI管理驾驶舱',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    provider,
    isPartOf: aipProductSystem,
    description: '企业管理的辅助决策中枢，帮助企业实现从战略到执行的自主智能运行。',
    url: `${SITE_URL}/aip/aivault`
  },
  application: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: '业务应用',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    provider,
    isPartOf: aipProductSystem,
    description: '应用模块集成于统一平台，解决运营管理、采销流通到生态协同的全链路经营问题。',
    url: `${SITE_URL}/aip/application`
  },
  trantor: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Trantor软件构建平台',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    provider,
    isPartOf: aipProductSystem,
    description: '可视化配置与低代码方式快速构建复杂业务系统。',
    url: `${SITE_URL}/aip/trantor`
  }
};
